// extracted by mini-css-extract-plugin
export var dropdownIcon = "_q3-6";
export var imgContainer = "_q3-3";
export var menuIcon = "_q3-5";
export var pillWrapper = "_q3-2";
export var pillsContainer = "_q3-1";
export var subscriptionCard = "_q3-0";
export var subscriptionLogo = "_q3-4";